import { Helmet } from "react-helmet-async";

/**
 * Editorial PageMeta — injects title, description, OG/twitter into <head>.
 * Falls back to sensible defaults when fields aren't provided.
 */
export default function PageMeta({ title, description, image, type = "website", path }) {
  const fullTitle = title
    ? (title.includes("Carlton") ? title : `${title} | Carlton Elleker Chase`)
    : "Carlton Elleker Chase | A modern London law firm";
  const desc = description ||
    "Carlton Elleker Chase is a modern London law firm advising corporates, founders, funds and private clients across six core departments.";
  const url = typeof window !== "undefined" ? `${window.location.origin}${path || window.location.pathname}` : "";
  const img = image && image.startsWith("/") && typeof window !== "undefined"
    ? `${window.location.origin}${image}` : image;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
      {url && <link rel="canonical" href={url} />}
    </Helmet>
  );
}
